import React from 'react'
import styled from 'styled-components'

import { Instagram } from '../shared/icons'

import {
  mobileVw,
  desktopVw,
  fonts,
  colors,
  desktopBreakpoint,
} from '../../styles'

import { useLocale, useSiteQuery } from '../../hooks'

export const InstagramText = ({ instagramSectionButtonText = null }) => {
  const { instagramLink, instagramBlockText } = useSiteQuery()
  const locale = useLocale();
  return (
    <TextWrapper>
      <Title>Ma Communauté Maille</Title>
      <Subtitle>{instagramBlockText.instagramBlockText}</Subtitle>
      <a
        href={instagramLink}
        alt='Ce lien va ouvrir une nouvelle fenêtre: Maille instagram'
      >
        <Button>
          <InstagramIcon />
          {
            instagramSectionButtonText && locale !== 'fr' ? instagramSectionButtonText : `Rejoignez-nous`
          }
        </Button>
      </a>
    </TextWrapper>
  )
}

const TextWrapper = styled.div`
  color: ${colors.white};
  text-align: center;
  padding: 0 ${mobileVw(16)};

  @media (min-width: ${desktopBreakpoint}) {
    padding: 0 ${desktopVw(125)};
    text-align: left;
  }
`

const Title = styled.h2`
  padding: ${mobileVw(43)} ${mobileVw(30)} 0;
  font-family: ${fonts.splandor};
  font-size: ${mobileVw(50)};
  line-height: ${mobileVw(40)};

  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(54)};
    line-height: ${desktopVw(52)};
    padding: 0;
  }
`

const Subtitle = styled.h3`
  padding: ${mobileVw(10)} ${mobileVw(8)} ${mobileVw(24)};
  font-family: ${fonts.mrs};
  font-size: ${mobileVw(16)};
  line-height: ${mobileVw(20)};

  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(20)};
    line-height: ${desktopVw(24)};
    padding: ${desktopVw(20)} 0;
  }
`
const Button = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${fonts.tivoli};
  font-size: ${mobileVw(20)};
  letter-spacing: ${mobileVw(2)};
  line-height: ${mobileVw(20)};
  height: ${mobileVw(48)};
  background-color: ${colors.mailleGold};
  color: ${colors.white};
  text-transform: uppercase;
  cursor: pointer;

  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(18)};
    line-height: ${desktopVw(16)};
    padding: ${desktopVw(10)} 0;
    height: ${desktopVw(56)};
    letter-spacing: ${desktopVw(1.8)};
  }
`

const InstagramIcon = styled(Instagram)`
  fill: ${colors.white};
  height: 100%;
  width: ${mobileVw(30)};
  margin-right: ${mobileVw(10)};
  padding: ${mobileVw(5)};

  @media (min-width: ${desktopBreakpoint}) {
    height: 100%;
    margin-right: ${desktopVw(10)};
    width: ${desktopVw(30)};
    padding: ${desktopVw(5)};
  }
`

export default InstagramText
